import React from 'react';
import { HeartHandshake } from 'lucide-react';
import ModulePageLayout, { Section, FeatureGrid, Steps } from '../../components/ModulePageLayout';
import { getModule } from '../../data/modules';

export default function MfafPage() {
  const module = getModule('mfaf')!;
  return (
    <ModulePageLayout module={module} Icon={HeartHandshake}>
      <Section title='"Credit on Credit"'>
        <p className="text-gray-700 leading-relaxed">
          Millions of people are "credit invisible" — they lack the credit history to qualify for loans, even
          though friends and family regularly help with rent, tuition, or car payments. Money From A Friend
          turns that informal support into a formal, credit-bureau-reportable event — even when the loan is
          later forgiven.
        </p>
      </Section>

      <Section title="From Informal Help to Formal Credit">
        <Steps
          items={[
            'An assister (the person providing funds) and a recipient set up a formalized payment agreement — for rent, tuition, a car payment, insurance, or a business expense.',
            'Loan terms are defined: repayment amount, interest rate (can be 0% for family), installment plan, and due date.',
            'Payments are recorded and reported to Equifax, TransUnion, and Experian — tracked for both FICO and ScoreTrade score impact.',
            'If needed, the loan can be partially or fully forgiven through sole-assister, multi-assister, system, or peer-pool forgiveness — and it still reports positively.',
          ]}
        />
      </Section>

      <Section title="Built for Real Situations">
        <FeatureGrid
          items={[
            { title: 'Convertible Loans', body: "Can't repay in cash? Convert to equity, service (labor exchange), or a formal debt-to-gift write-off — still reported." },
            { title: 'Peer Assistance Pools', body: 'Groups pool funds and disburse to members in need through democratic voting — a digital ROSCA with credit reporting.' },
            { title: 'Dispute Resolution', body: 'A formal process for disagreements between assister and recipient: Open → Resolved → Closed.' },
            { title: 'Subscription Tiers', body: 'Standard ($5/mo) for basic recording and reporting; Premium ($15/mo) adds templates, forgiveness tracking, and impact analytics.' },
          ]}
        />
      </Section>
    </ModulePageLayout>
  );
}
